import React, { createContext, useContext, useEffect, useState } from "react";
import axios from "axios";
import { useNavigate } from "react-router-dom";
import { API_BASE_URL } from "../config";

const AuthContext = createContext();

export const AuthProvider = ({ children }) => {
    const [user, setUser] = useState(null);
    const [loading, setLoading] = useState(true); // Add a loading state
    const navigate = useNavigate();

    const verifyToken = async (token) => {
        try {
            // Call your backend to verify the token
            await axios.get(`${API_BASE_URL}/auth/verify-token`, {
                headers: { Authorization: `Bearer ${token}` },
            });
            return true;
        } catch (err) {
            console.error("Invalid token:", err);
            return false;
        }
    };

    useEffect(() => {
        const checkToken = async () => {
            const token = localStorage.getItem("authToken");
            const id = localStorage.getItem("userId");
            const email = localStorage.getItem("email");
            const firstName = localStorage.getItem("firstName");
            const lastName = localStorage.getItem("lastName");
            const role = localStorage.getItem("role");
            if (token) {
                const isValid = await verifyToken(token);
                if (isValid) {
                    setUser({ token, id, email, firstName, lastName, role });
                } else {
                    localStorage.removeItem("authToken");
                    localStorage.removeItem("userId");
                    localStorage.removeItem("email");
                    localStorage.removeItem("firstName");
                    localStorage.removeItem("lastName");
                    localStorage.removeItem("role");
                    navigate("/login");
                }
            }
            setLoading(false);
        };
        checkToken();
    }, [navigate]);


    // Throws on failure instead of alert()-ing internally, so the caller
    // (the Login page) can show the error inline like every other form in
    // the admin panel, rather than a jarring native alert. This used to
    // swallow the error entirely, which also made Login.jsx's own
    // try/catch around this call permanently dead code - it could never
    // run, because nothing ever reached it.
    const login = async (email, password) => {
        const response = await axios.post(`${API_BASE_URL}/auth/login`, {
            email,
            password,
        });
        const { token, id, email: accountEmail, firstName, lastName, role } = response.data;
        localStorage.setItem("authToken", token);
        localStorage.setItem("userId", id);
        localStorage.setItem("email", accountEmail);
        localStorage.setItem("firstName", firstName);
        localStorage.setItem("lastName", lastName);
        localStorage.setItem("role", role)

        setUser({ token, id, email: accountEmail, firstName, lastName, role });
        navigate("/");
    };

    const logout = async () => {
        const token = localStorage.getItem("authToken");
        try {
            // Best-effort: this bumps the account's tokenVersion server-side,
            // which is what actually invalidates the token - clearing
            // localStorage alone only forgets it on this device.
            await axios.post(
                `${API_BASE_URL}/auth/logout`,
                {},
                { headers: { Authorization: `Bearer ${token}` } },
            );
        } catch (err) {
            console.error("Logout request failed:", err);
        }
        localStorage.removeItem("authToken");
        localStorage.removeItem("userId");
        localStorage.removeItem("email");
        localStorage.removeItem("firstName");
        localStorage.removeItem("lastName");
        localStorage.removeItem("role")
        setUser(null);
        navigate("/login");
    };

    return (
        <AuthContext.Provider value={{ user, loading, login, logout }}>
            {children}
        </AuthContext.Provider>
    );
};

export const useAuth = () => useContext(AuthContext);
